import { render, staticRenderFns } from "./collectTag.vue?vue&type=template&id=27df60b9&scoped=true&"
import script from "./collectTag.vue?vue&type=script&lang=js&"
export * from "./collectTag.vue?vue&type=script&lang=js&"
import style0 from "./collectTag.vue?vue&type=style&index=0&id=27df60b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df60b9",
  null
  
)

export default component.exports